import con from '@services/connection'
import { composicaoFundo } from '@constants/URL'

class APIComposicaoFundos {
  async carregar({ id_ativo }) {
    const r = await con.get(composicaoFundo.manage + `${id_ativo}`)

    if (r && r.status === 200) {
      r.value.forEach((item) => {
        item.alocacao_percentual *= 100
        item.subclasse = item.subclasse || 'Sem subclasse'
      })
    }

    return r || {}
  }

  async salvar({ lista, id_ativo }) {
    const dados = lista.map((item) => {
      return {
        nome_ativo: item.nome_ativo,
        tipo: item.tipo,
        classe: item.classe,
        alocacao_percentual: Math.round10(item.alocacao_percentual / 100, -2),
        id_ativo_composicao: item.id_ativo_composicao || item.id_ativo,
        subclasse: item.subclasse === 'Sem subclasse' ? '' : item.subclasse,
      }
    })

    const data = {
      data: JSON.stringify(dados),
    }

    const r = await con.put(composicaoFundo.manage + `${id_ativo}`, data)

    return r || {}
  }
}

const apiComposicaoFundos = new APIComposicaoFundos()
export default apiComposicaoFundos
